import React from "react";
import { motion } from "framer-motion";
import "./ShopByCategory.css";

const categories = [
  {
    name: "Necklaces",
    image:
      "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-165d7a1173.jpg?v=1716629147&width=450",
  },
  {
    name: "Pendants",
    image:
      "https://spinellejewelry.com/cdn/shop/files/78APTY.jpg?v=1721802822&width=750",
  },
  {
    name: "Earrings",
    image:
      "https://spinellejewelry.com/cdn/shop/files/HYER625_4.jpg?v=1721713566&width=450",
  },
  {
    name: "Bracelets",
    image:
      "https://spinellejewelry.com/cdn/shop/files/women-bangle-3dm-stl-obj-fbx-renders-details-3d-model-c706cebe37.jpg?v=1716545248&width=450",
  },
];

const ShopByCategory = () => {
  return (
    <section className="shop-category-section">
  <motion.h2
  className="section-title"
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
>
  <span className="title-highlight">
    Shop By Categories
  </span>
  <span className="background-text">CATEGORY</span>
</motion.h2>


      <div className="category-grid">
        {categories.map((cat, i) => (
          <motion.div
            key={i}
            className="category-card"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
          >
            <img
              src={cat.image}
              alt={cat.name}
              className="category-image"
            />
            <div className="category-overlay">
              <span>{cat.name}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ShopByCategory;
